import { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import HelpText from '../help/support-thread'

import { getSupportThreadMessages, markSupportThreadRead, replyToSupportThread, closeSupportThread } from '/providers/studio-api'
import Menu from '/components/support/nav-menu'

import Thread from '/components/support/thread'
import Messages from '/components/support/messages'
import Form from '/components/support/reply-form'

const SupportThread = () => {

  const { thread_id } = useParams()
  const { apiSource, apiKey, setProcessing, refreshSupportUnreadCount } = useContext(AppContext)

  const [thread, setThread] = useState()
  const [messages, setMessages] = useState([])
  const [sent, setSent] = useState(false)
  const [closed, setClosed] = useState(false)


  useEffect(() => {
    getMessages()
  }, [])

  const getMessages = async () => {
    const result = await getSupportThreadMessages({ apiSource, apiKey, thread_id })
    if (result.ok) {
      setMessages(result.messages)
      setThread(result.thread)
      await markSupportThreadRead({ apiSource, apiKey, thread_id })
      refreshSupportUnreadCount()
    }
  }

  const closeThread = async () => {
    setProcessing(true)
    await closeSupportThread({ apiSource, apiKey, thread_id })
    setProcessing(false)
    setClosed(true)
  }

  const reply = async ({ message, close }) => {
    setProcessing(true)
    await replyToSupportThread({ apiSource, apiKey, thread_id, message, close })
    setProcessing(false)
    setSent(true)
  }

    if (closed) return (
    <PageWrapper title="Support" HelpText={HelpText} heading="Support Thread" menu={<Menu />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <div className="flex flex-col justify-around w-full items-center gap-5">
          <h2>Thank you for closing this support thread</h2>
          <p>Do not hesitate to re-open the thread or raise a new request if you have further difficulties.</p>
        </div>
      </div>
    </PageWrapper>
  )

  if (sent) return (
    <PageWrapper title="Support" HelpText={HelpText} heading="Support Thread" menu={<Menu />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <div className="flex flex-col justify-around w-full items-center gap-5">
          <h2>Your reply has been sent.</h2>
          <p>We aim to respond to all requests within 48 hours Monday to Friday.</p>
        </div>
      </div>
    </PageWrapper>
  )

  return (
    <PageWrapper title="Support" HelpText={HelpText} heading="Support Thread" menu={<Menu />}>
      <div className='flex flex-col gap-5 overflow-y-auto'>
        <Thread thread={thread} closeThread={closeThread} />
        <Messages messages={messages} />
        <Form messages={messages} reply={reply} />
      </div>
    </PageWrapper>
  )
}

export default SupportThread
